export default function (error: unknown, data?: unknown) {
  window.dispatchEvent(
    new CustomEvent('reportErrorToFaro', {
      detail: data ? { error, data } : { error },
    })
  );
}
